<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center pt-3">ประวัติการจ่ายเงินเดือน</h2>

            <div class="col-12 table-responsive">
                <table style="text-align: center" class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">เงินรับสุทธิ</th>
                        <th scope="col">ช่องทางการจ่ายเงิน</th>
                        <th scope="col">ผู้บันทึก</th>
                        <th scope="col">สถานะปิดงวด</th>
                        <th scope="col">ดูข้อมูล</th>
                        <th scope="col">พิมพ์</th>
                        <th scope="col">ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in paymentSalaryList">
                        <td>{{data.payment_date | moment('DD/MM/YYYY')}}</td>
                        <td>{{data.net_total | currency}}</td>
                        <td>
                            <template v-if="employee.transaction && employee.transaction.transaction_type">
                                {{employee.transaction.transaction_type.name}}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.user">
                                {{data.user.name}}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.close_status">
                                ปิดงวด
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <button class="btn btn-info"
                                @click="goToPaymentSlip(data.id)">
                                <icon name="eye"></icon>
                                ดูข้อมูล
                            </button>
                        </td>
                        <td>
                            <button class="btn btn-primary"
                                    @click="showprintToPaymentSlip(data.id)">
                                <icon name="print" style="width: 25px"></icon>
                                พิมพ์
                            </button>
                        </td>
                        <td>
                            <button type="button" class="btn btn-danger" @click="showDeletePaymentSalary(data.id)">
                                <icon name="trash-alt"></icon>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
<!--            <div>test</div>-->
            <div v-if="paymentSalaryList.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getPaymentSalaryList">
                </vue-pagination>
            </div>
            <br>
            <b-modal size="md" hide-header hide-footer ref="delete_item">
                <div>
                    <delete-confirm-modal @submit="deletePaymentSalary">
                    </delete-confirm-modal>
                </div>
            </b-modal>
            <b-modal size="md" hide-header hide-footer ref="ChooseLang">
                <div>
                    <choose-lang-modal @submit="printToPaymentSlip">
                    </choose-lang-modal>
                </div>
            </b-modal>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
<!--        <pre class="alert-primary">{{employee.id}}</pre>-->
<!--        <pre class="alert-success">{{dataPaginate}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../../Pagination";
    import { domain } from "../../../../util/Constants";
    import DeleteConfirmModal from "../../../Utility/DeleteConfirmModal";
    import ChooseLangModal from "./Modal/ChooseLangModal";
    import Loading from "../../../Utility/Loading";

    export default {
        name: "PaymentSalaryHistoryList",
        components: {
            Loading,
            DeleteConfirmModal,
            VuePagination,
            ChooseLangModal
        },
        created(){
            this.$store.dispatch("PaymentSalary/setPaymentSalary",{
                employee_id : this.employee.id,
                page : 1,
            })
        },
        data() {
            return {
                msg : '',
                Lang : '',
                status_loading : 1,
                delete_id : null,
                slip_id : null,
                items: [
                    {
                        text: "รายการเงินเดือน",
                        to: {name: "payment-salary"}
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
            }
        },
        computed: {
            ...mapState({
                paymentSalaryList:state=>{
                    return state.PaymentSalary.paymentSalaryList;
                },
                last_payment:state=>{
                    return state.PaymentSalary.last_payment;
                },
                dataPaginate:state=>{
                    return state.PaymentSalary.dataPaginate;
                },
                employee:state=>{
                    return state.Employee.employeeForm;
                },
            }),
        },
        methods:{
            getPaymentSalaryList(){
                const page = this.dataPaginate.current_page;
                this.$store.dispatch("PaymentSalary/setPaymentSalary",{
                    page : page,
                    employee_id : this.employee.id,
                })
            },
            goToPaymentSlip(payment_salary_id){
                this.$store.dispatch("PaymentSalary/showPaymentSalaryByID",payment_salary_id)
                    this.$router.push({
                        name : "payment-salary-slip"
                    })
            },
            printToPaymentSlip(value){
                if(value.Lang == 'th'){
                    window.open(domain+"/DisplaySalaryEmployee?id="+this.slip_id);
                }else if(value.Lang == 'mm'){
                    window.open(domain+"/payment-salary-slip-pdf?id="+this.slip_id);
                }
            },
            showprintToPaymentSlip(payment_salary_id){
                this.slip_id = payment_salary_id;
                this.$refs.ChooseLang.show();
                // window.open(domain+"/payment-salary-slip-pdf?id="+payment_salary_id);
            },
            showDeletePaymentSalary(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            deletePaymentSalary(value){
                this.$refs.delete_item.hide();
                if(value){
                    this.showLoadingModal();
                    this.msg = 'กรุณารอสักครู่';
                    this.status_loading = 1;
                    this.$store.dispatch("PaymentSalary/delete",this.delete_id).then(()=>{
                        this.showLoadingModal();
                        this.msg = 'ลบรายการสำเร็จ';
                        this.status_loading = 2;
                        this.$store.dispatch("PaymentSalary/setPaymentSalary",{
                            page : this.dataPaginate.current_page,
                            employee_id : this.employee.id,
                        })
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
